<script>
  import { scaleLinear, scaleTime } from 'd3-scale'
  import { max, extent } from 'd3-array'
  import { getContext } from 'svelte'

  import { formatThousands, formatDateLong, formatDateShort } from './functions'

  import { onMount } from 'svelte'
  import Axis from './components/Axis.svelte'
  import AxisRight from './components/AxisRight.svelte'
  import Line from './components/Line.svelte'
  import Area from './components/Area.svelte'
  import { colors } from './colors.js'
  import Hover from './components/Hover.svelte'
  import Grid from './components/Grid.svelte'

  let { nData, cData, margin } = getContext('chart')
  let nationalData = nData()
  let cumulativeData = cData()

  let width
  let height = 250
  let latestVaccCount
  let latestDate
  let days = 150
  let defaultBarColor
  let xScale, yScale
  let xTicks, yTicks
  let mobile = true
  if (window.innerWidth > 500) mobile = false

  // cumulativeData = cumulativeData.filter(
  //   (d, i) => i > cumulativeData.length - days
  // )

  cumulativeData.forEach((d) => {
    d.casesSevenDays = +d['7_day_weekly_average']
    d.vaccinationsSevenDays = +d['vaccinations_7_day_average']
  })

  $: xScale = scaleTime()
    .range([margin.left, width - margin.right])
    .domain(extent(cumulativeData, (d) => d.date))

  $: yScale = scaleLinear()
    .range([height - margin.bottom, margin.top])
    .domain([0, max(cumulativeData, (d) => d.casesSevenDays)])

  $: yScale2 = scaleLinear()
    .range([height - margin.bottom, margin.top])
    .domain([0, max(cumulativeData, (d) => d.vaccinationsSevenDays)])

  $: xTicks = xScale.ticks(5)
  $: yTicks = yScale.ticks(5)
  $: yTicks2 = yScale2.ticks(5)
</script>

<div class="chart-wrap">
  <div class="chart-title">New confirmed daily cases (7-day average)</div>
  <div class="chart-description" />
  <div class="chart chart-vax-cases chart-block" bind:clientWidth={width}>
    <div class="tooltip">Tooltip</div>
    <div class="latest-data">
      <div class="latest-number">{formatThousands(latestVaccCount)}</div>
      <div class="latest-date">{formatDateLong(latestDate)}</div>
    </div>
    <svg {width} {height}>
      <Grid
        type="y"
        ticks={{ x: xTicks, y: yTicks }}
        scale={{ x: xScale, y: yScale }}
        {height}
        {width}
      />
      <Axis
        type="y"
        {height}
        {width}
        scale={{ x: xScale, y: yScale }}
        ticks={{ x: xTicks, y: yTicks }}
      />
      <Axis
        type="x"
        {height}
        {width}
        scale={{ x: xScale, y: yScale }}
        ticks={{ x: xTicks, y: yTicks }}
      />

      <Area
        scale={{ x: xScale, y: yScale }}
        values={{ x: 'date', y: 'casesSevenDays' }}
        {height}
        {width}
        data={cumulativeData}
        fill={colors['blue500']}
      />

      <Line
        {height}
        {width}
        stroke={colors['blue500']}
        strokeWidth="3"
        scale={{ x: xScale, y: yScale }}
        data={cumulativeData}
        values={{ x: 'date', y: 'casesSevenDays' }}
      />

      {#if !mobile}
        <Hover
          type="x"
          {height}
          {width}
          scale={{ x: xScale, y: yScale }}
          ticks={{ x: xTicks, y: yTicks }}
          data={cumulativeData}
          values={{ x: 'date', y: 'casesSevenDays' }}
        />
      {/if}
    </svg>
  </div>
  {#if !mobile}
    <div class="note">
      Move the sliders at the bottom of the chart to select a time period.<br />
      Chart inspired by
      <a
        href="http://interaktiv.tagesanzeiger.ch/2021/corona-wellen-zeitvergleich-schweiz/"
        >Tages Anzeiger</a
      >
    </div>
  {/if}
</div>

<style>
  .chart {
    position: relative;
    font-family: 'Titillium Web', Arial, Helvetica, sans-serif;
    width: 100%;

    min-height: 250px;
    margin: 0 auto;
  }

  .latest-data {
    position: absolute;
    top: 20px;
    left: 20px;
    line-height: 100%;
    left: -10000px;
  }
  .latest-number {
    background: var(--darkgreen);
    color: #fff;
    padding: 4px 6px;
    font-size: 80%;
    border-radius: 5px;
  }
  .latest-date {
    font-size: 70%;
    margin-top: 2px;
    margin-bottom: 3px;
  }
  svg {
    margin-top: 18px;
  }
  .note {
    font-family: Arial, Helvetica, sans-serif;
    line-height: 0.8rem;
    font-size: 0.8rem;
    padding-bottom: 10px;
  }
</style>
